'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tcomb = require('tcomb');

var _tcomb2 = _interopRequireDefault(_tcomb);

var _tcombReact = require('tcomb-react');

var _reactFlexview = require('react-flexview');

var _reactFlexview2 = _interopRequireDefault(_reactFlexview);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PickerTop = (_dec = (0, _utils.skinnable)(), _dec2 = (0, _tcombReact.props)({
  fixed: _tcomb2.default.maybe(_tcomb2.default.Boolean),
  handleClick: _tcomb2.default.maybe(_tcomb2.default.Function),
  nextDate: _tcomb2.default.maybe(_tcomb2.default.Function),
  previousDate: _tcomb2.default.maybe(_tcomb2.default.Function),
  value: _tcomb2.default.union([_tcomb2.default.String, _tcomb2.default.Number]),
  weekDays: _tcomb2.default.maybe(_tcombReact.ReactChildren),
  prevIconClassName: _tcomb2.default.String,
  nextIconClassName: _tcomb2.default.String
}), (0, _utils.pure)(_class = _dec(_class = _dec2(_class = function (_React$Component) {
  _inherits(PickerTop, _React$Component);

  function PickerTop() {
    _classCallCheck(this, PickerTop);

    return _possibleConstructorReturn(this, (PickerTop.__proto__ || Object.getPrototypeOf(PickerTop)).apply(this, arguments));
  }

  _createClass(PickerTop, [{
    key: 'template',
    value: function template(_ref) {
      var value = _ref.value,
          fixed = _ref.fixed,
          previousDate = _ref.previousDate,
          nextDate = _ref.nextDate,
          handleClick = _ref.handleClick,
          weekDays = _ref.weekDays,
          prevIconClassName = _ref.prevIconClassName,
          nextIconClassName = _ref.nextIconClassName;

      return _react2.default.createElement(
        _reactFlexview2.default,
        { column: true, className: 'react-datepicker-top' },
        _react2.default.createElement(
          _reactFlexview2.default,
          { shrink: false, className: 'display' },
          _react2.default.createElement(
            _reactFlexview2.default,
            {
              className: 'react-datepicker-button button-left',
              onClick: previousDate,
              vAlignContent: 'center', shrink: false
            },
            _react2.default.createElement('i', { className: prevIconClassName })
          ),
          _react2.default.createElement(
            _reactFlexview2.default,
            {
              className: (0, _classnames2.default)('react-datepicker-button button-label', { fixed: fixed }),
              onClick: handleClick,
              hAlignContent: 'center', vAlignContent: 'center', grow: true
            },
            _react2.default.createElement(
              'strong',
              null,
              value
            )
          ),
          _react2.default.createElement(
            _reactFlexview2.default,
            {
              className: 'react-datepicker-button button-right',
              onClick: nextDate,
              vAlignContent: 'center', shrink: false
            },
            _react2.default.createElement('i', { className: nextIconClassName })
          )
        ),
        weekDays
      );
    }
  }]);

  return PickerTop;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = PickerTop;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-datepicker/lib/PickerTop.js
 ** module id = 268
 ** module chunks = 0
 **/